import styled from 'styled-components';

const Wrapper = styled.section`
  .filters-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1.5rem;
  }

  .filters-header h3 {
    font-family: 'Playfair Display', serif;
    font-size: 1.25rem;
    font-weight: 700;
    color: #111718;
    margin: 0;
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }

  .form-control {
    h5 {
      font-size: 0.75rem;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.1em;
      color: #111718;
      margin-bottom: 0.75rem;
    }
  }

  .search-input {
    width: 100%;
    padding: 0.625rem 0.75rem;
    padding-right: 2.5rem;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    color: #111718;
    transition: all 0.2s;
  }

  .search-input:focus {
    outline: none;
    border-color: #111718;
    box-shadow: 0 0 0 1px #111718;
  }

  .search-input::placeholder {
    color: #9ca3af;
  }

  /* Category Buttons */
  .category-buttons {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  button {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.25rem 0;
    background: transparent;
    border: none;
    font-size: 0.875rem;
    color: #6b7280;
    cursor: pointer;
    transition: color 0.2s;
    text-align: left;
  }

  button:hover {
    color: #111718;
  }

  button.active {
    color: #111718;
    font-weight: 500;
  }

  /* Shop/Company Select */
  .ShopName {
    width: 100%;
    padding: 0.625rem 0.75rem;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    color: #111718;
    cursor: pointer;
    transition: all 0.2s;
  }

  .ShopName:focus {
    outline: none;
    border-color: #111718;
  }

  /* Colors */
  .colors {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
  }

  .color-btn {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    border: 1px solid #d1d5db;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    opacity: 0.7;
    
    svg {
      font-size: 0.625rem;
      color: #ffffff;
    }
  }

  .color-btn:hover {
    opacity: 1;
    transform: scale(1.1);
  }

  .color-btn.active {
    opacity: 1;
    box-shadow: 0 0 0 2px #111718, 0 0 0 4px #ffffff;
  }

  .all-btn {
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
    border-radius: 0.25rem;
    background: #f3f4f6;
    color: #6b7280;
    opacity: 1;
  }

  .all-btn:hover {
    background: #e5e7eb;
    color: #111718;
  }

  .all-btn.active {
    background: #111718;
    color: #ffffff;
  }

  /* Price Range */
  .price-info {
    display: flex;
    justify-content: space-between;
    font-size: 0.875rem;
    color: #6b7280;
    margin-bottom: 0.75rem;
  }

  .price {
    font-size: 0.875rem;
    font-weight: 500;
    color: #111718;
    margin-top: 0.5rem;
    margin-bottom: 0;
  }

  input[type="range"] {
    width: 100%;
    height: 4px;
    background: #e5e7eb;
    border-radius: 2px;
    appearance: none;
    cursor: pointer;
  }

  input[type="range"]::-webkit-slider-thumb {
    appearance: none;
    width: 1rem;
    height: 1rem;
    background: #111718;
    border-radius: 50%;
    cursor: pointer;
  }

  input[type="range"]::-moz-range-thumb {
    width: 1rem;
    height: 1rem;
    background: #111718;
    border-radius: 50%;
    cursor: pointer;
    border: none;
  }

  /* Shipping Checkbox */
  .shipping {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    
    label {
      font-size: 0.875rem;
      color: #6b7280;
      cursor: pointer;
    }
    
    input[type="checkbox"] {
      width: 1rem;
      height: 1rem;
      border-radius: 0.25rem;
      border: 1px solid #d1d5db;
      cursor: pointer;
      accent-color: #111718;
    }
  }

  /* Clear Button */
  .clear-btn {
    width: 100%;
    padding: 0.75rem 1rem;
    margin-top: 1rem;
    background: transparent;
    border: 1px solid #111718;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    font-weight: 700;
    color: #111718;
    cursor: pointer;
    transition: all 0.2s;
  }

  .clear-btn:hover {
    background: #111718;
    color: #ffffff;
  }

  @media (min-width: 1024px) {
    .content {
      position: sticky;
      top: 6rem;
    }
  }
`;

export default Wrapper;
